import { parse } from 'url';

type GetHostFromUrl = (webLinkUrl: string) => string;
export const getHostFromUrl: GetHostFromUrl = (webLinkUrl: string) => {
  const { host } = parse(webLinkUrl);

  return host ?? '';
};
